const COUNTRY_TERM_MAP = {
    se: {
        LTP: "LTP_SWE_alt",
        STP: "STP_SWE_alt",
    },
    no: {
        LTP: "LTP_NOR_alt",
        STP: "STP_NOR_alt",
    },
    fi: {
        LTP: "LTP",
        STP: "STP",
    },
};

export const getCountry = () => {
    return (
        document?.documentElement?.getAttribute("country")?.toLowerCase() || ""
    );
};

export const getTermKey = (term, country) => {
    const normalizedCountry = country?.toLowerCase() || "";
    return COUNTRY_TERM_MAP[normalizedCountry]?.[term] || term;
};

export const getLtpStpKeys = (country) => {
    return {
        LTP_KEY: getTermKey("LTP", country),
        STP_KEY: getTermKey("STP", country),
    };
};
